// © 2026 Camp Promethean, LLC. All Rights Reserved.

export const ANCORA_COMING_SOON_TOAST =
  "Camp Promethean's online academy — interactive courses, verified certifications, and career tools for cannabis cultivation.";

export function AncoraComingSoonTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Ancora — Coming Soon</p>
      <p>
        The Camp Promethean online academy helps growers build skills, validate expertise,
        and share credentials with employers across the industry.
      </p>
      <div>
        <p className="font-medium">What&apos;s included</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>
            <span className="font-medium">Courses</span> — structured lessons and assessments
            covering everyday cultivation practices
          </li>
          <li>
            <span className="font-medium">Advanced Courses</span> — deeper topics for
            experienced growers ready to level up
          </li>
          <li>
            <span className="font-medium">Certifications</span> — verified credentials from
            completed coursework and assessments
          </li>
          <li>
            <span className="font-medium">Resume Builder</span> — turn academy achievements
            into a professional profile for hiring
          </li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Learn faster, prove your skills, and get discovered — built for cannabis cultivation
        teams at every stage.
      </p>
    </div>
  );
}
